import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SchoolResponseDto } from "../../shared/dtos/school/SchoolResponseDto";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";

export interface SchoolState {
  loadingSchool: boolean;
  loadingSchoolUpdate: boolean;
  errorLoadingSchool: string | null;
  errorUpdatingSchool: string | null;
  school: SchoolResponseDto | null;
  serverStatus: ServerStatusPayload | number | null;
}

const initialState: SchoolState = {
  loadingSchool: false,
  loadingSchoolUpdate: false,
  errorLoadingSchool: null,
  errorUpdatingSchool: null,
  school: null,
  serverStatus: null,
};

export const schoolSlice = createSlice({
  name: "school",
  initialState,
  reducers: {
    setLoadingSchool: (state) => {
      state.loadingSchool = true;
      state.errorLoadingSchool = null;
    },
    setLoadingSchoolUpdate: (state) => {
      state.loadingSchoolUpdate = true;
      state.errorUpdatingSchool = null;
    },
    setErrorLoadingSchool: (state, action: PayloadAction<string | null>) => {
      state.loadingSchool = false;
      state.errorLoadingSchool = action.payload;
    },
    setErrorUpdatingSchool: (state, action: PayloadAction<string | null>) => {
      state.loadingSchoolUpdate = false;
      state.errorUpdatingSchool = action.payload;
    },
    setSchool: (state, action: PayloadAction<SchoolResponseDto>) => {
      state.loadingSchool = false;
      state.errorLoadingSchool = null;
      state.school = action.payload;
    },
    updateSchoolSuccess: (state, action: PayloadAction<SchoolResponseDto>) => {
      state.loadingSchoolUpdate = false;
      state.errorUpdatingSchool = null;
      state.school = action.payload;
    },
    setServerResponseStatus(
      state,
      action: PayloadAction<ServerStatusPayload | number | null>,
    ) {
      state.serverStatus = action.payload;
    },
  },
});

export const schoolActions = schoolSlice.actions;
export default schoolSlice.reducer;
